export default __webpack_public_path__ + "e57c60c3219469302cb05087d68b8151.png";